module.exports = __webpack_public_path__ + "static/img/library-banner.a54b46c5.png";